import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';

export const LoadingPlaceholder = () => (
  <Paper
    sx={{
      display: 'flex',
      flexDirection: 'column',
      p: 2,
      my: 2,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        mb: 2,
      }}
    >
      <Skeleton
        animation="wave"
        height={40}
        sx={{ position: 'relative' }}
        variant="circular"
        width={40}
      />
      <Box sx={{ flexGrow: 1, ml: 2 }}>
        <Skeleton width="25%" />
        <Skeleton width="50%" />
      </Box>
    </Box>
    <Box>
      <Skeleton width="40%" />
      <Skeleton />
    </Box>
  </Paper>
);
